var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCommunicationUnknown = function SvgCommunicationUnknown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 25 25"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#communication-unknown_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.979,
    cy: 12.089,
    r: 10,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#21272C",
    d: "M9.639 9.249c.303-.789.768-1.389 1.393-1.8.625-.415 1.386-.622 2.282-.622.667 0 1.26.107 1.778.322.523.21.926.497 1.211.86.29.36.434.752.434 1.177 0 .354-.063.672-.189.952-.126.275-.28.51-.462.707a8.956 8.956 0 0 1-.721.693c-.29.256-.518.476-.686.658-.168.177-.31.39-.427.637a1.946 1.946 0 0 0-.175.84h-1.883c0-.462.065-.873.196-1.232.135-.36.294-.66.476-.903.187-.248.425-.525.714-.833.191-.206.34-.371.448-.497.107-.131.196-.271.266-.42.07-.15.105-.306.105-.47a.778.778 0 0 0-.322-.65c-.21-.168-.474-.252-.791-.252-.345 0-.667.116-.966.35a2.11 2.11 0 0 0-.679.938zm4.767 7.84h-2.548v-2.436h2.548z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "communication-unknown_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.979 2.089h20v20h-20z"
  })))));
};
export default SvgCommunicationUnknown;